import Select from "react-select";
import Top from "./Top";
import Right from "./Right";
import { useEffect, useState } from "react";
import { server } from "../../server";
import { toast } from "react-toastify";
import { getUserFromToken } from "../../function";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";

function UpdateEvent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { event } = location.state || {};

  const [remainingEvents, setRemainingEvents] = useState({
    regular: 0,
    basic: 0,
  });

  const events = [
    { value: "wedding", label: "Wedding" },
    { value: "engagement", label: "Engagement" },
    { value: "pre-wedding", label: "Pre-Wedding" },
    { value: "maternity", label: "Maternity" },
    { value: "baby-shoot", label: "Baby Shoot" },
    { value: "events", label: "Events" },
    { value: "expo", label: "Expo" },
    { value: "conference", label: "Conference" },
    { value: "music-festival", label: "Music Festival" },
    { value: "marathon", label: "Marathon" },
    { value: "corporate-event", label: "Corporate Event" },
    { value: "fashion-show", label: "Fashion Show" },
    { value: "team-outing", label: "Team Outing" },
    { value: "dealers-meet", label: "Dealers Meet" },
    { value: "hackathons", label: "Hackathons" },
    { value: "family-day", label: "Family Day" },
    { value: "annual-summit", label: "Annual Summit" },
    { value: "corporate-sports", label: "Corporate Sports" },
    { value: "other", label: "Other" },
  ];

  const formatDateForInput = (isoDate) => {
    if (!isoDate) return "";
    return new Date(isoDate).toISOString().split("T")[0];
  };

  useEffect(() => {
    if (!event) return;

    setFormData({
      name: event.name || "",
      date: formatDateForInput(event.createdAt),
      eventType: event.eventType || "",
      description: event.description || "",
      pin: event.pin || "",
      phones: event.phones?.join(", ") || "",
      eventPhoto: null,
    });
  }, [event]);

  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    eventType: "",
    description: "",
    pin: "",
    phones: "",
    eventPhoto: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let eventPhotoUrl = event.eventPhoto || "";

      // 🖼️ Upload new image if selected
      if (formData.eventPhoto) {
        const fileName = `${Date.now()}-${formData.eventPhoto.name}`;

        const presignRes = await fetch(
          `${server}/PresignedUrl/GeneratePresignedUrl`,
          {
            method: "POST",
            headers: { Authorization: token },
            body: JSON.stringify({
              folder: "events",
              fileNames: [fileName],
            }),
          }
        );

        const raw = await presignRes.json();
        const uploadDetails = raw.urls[0];

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        let compressedFile = formData.eventPhoto;

        try {
          const compressedBlob = await imageCompression(
            formData.eventPhoto,
            options
          );

          compressedFile = new File(
            [compressedBlob],
            formData.eventPhoto.name,
            { type: formData.eventPhoto.type }
          );
        } catch (err) {
          console.error("Compression failed", err);
        }

        await fetch(uploadDetails.signedUrl, {
          method: "PUT",
          headers: { "Content-Type": uploadDetails.contentType },
          body: compressedFile,
        });

        eventPhotoUrl = uploadDetails.key;
      }

      // 🔥 UPDATE PAYLOAD
      const payload = {
        eventObjectId: event._id,
        name: formData.name,
        description: formData.description,
        eventPhoto: eventPhotoUrl,
        pin: formData.pin,
        phones: formData.phones
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean),
        eventType: formData.eventType,
        date: formData.date,
      };

      const response = await fetch(
        `https://b2i4nr8bza.execute-api.ap-south-1.amazonaws.com/Prod/Event/UpdateEvent`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Event Updated Successfully");
        navigate("/all-events");
      } else {
        toast.error(data?.message || "Update failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = getUserFromToken();
    if (!user?._id) return;

    const fetchMembership = async () => {
      try {
        const res = await fetch(
          `${server}/GetMembershipPlanAndHistory?userObjectId=${user._id}`,
          {
            headers: { Authorization: token },
          }
        );

        const data = await res.json();

        const plans = data?.plans || {};

        setRemainingEvents({
          regular: plans?.regular?.remainingEvents ?? 0,
          basic: plans?.basic?.remainingEvents ?? 0,
        });
      } catch (err) {
        console.error("Failed to load membership data", err);
      }
    };

    fetchMembership();
  }, [token]);

  return (
    <>
      <main>
        <Top />

        <div className="container">
          <div className="row g-3">
            <div className="col-lg-9 col-12 py-2">
              <section class="position-relative z-1">
                <div className="pb-3 d-flex flex-column flex-md-row gap-0 align-items-md-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Link
                      to="/all-events"
                      className="action-button-md bg-white-transparent rounded-circle"
                    >
                      <i className="bi bi-arrow-left fs-4 text-dark"></i>
                    </Link>
                    <div>
                      <h1 className="mb-0 h4 text-light lh-1 fw-medium ms-3">
                        Update Event
                      </h1>
                      <nav aria-label="breadcrumb" className="m-0 ms-3">
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <span>Home</span>
                          </li>
                          <li
                            className="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Existing Event
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </section>

              <section class="position-relative z-1">
                <div>
                  <form onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-lg-4 col-md-6">
                        <label className="label-text text-light mb-1 ms-3">
                          Event Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          class="form-control ps-3 normal-text bg-light border border-light rounded-3"
                          placeholder="Enter Event Name"
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Name your event.
                        </p>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <label className="label-text text-light mb-1 ms-3">
                          Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          className="form-control ps-3 normal-text bg-light border border-light rounded-3"
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          When did the event occur
                        </p>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <label className="label-text text-light mb-1 ms-3">
                          Type of Event <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={events}
                          placeholder="Select Event"
                          className="bg-light rounded-4"
                          isClearable
                          onChange={(opt) =>
                            setFormData((prev) => ({
                              ...prev,
                              eventType: opt?.value,
                            }))
                          }
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Select the type of event
                        </p>
                      </div>
                      <div className="col-lg-2 col-md-4">
                        {event?.eventPhoto && !formData.eventPhoto && (
                          <div className="ms-3 mt-2">
                            <img
                              src={event.eventPhoto}
                              alt="Event"
                              style={{
                                width: "120px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                            <p className="smtext m-0 mt-1 lh-1 light-text-white">
                              Current this event photo / can be updated
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <label className="label-text text-light mb-1 ms-3">
                          Event Photo
                          {formData.category === "regular" && (
                            <span className="text-danger"> *</span>
                          )}
                        </label>
                        <input
                          type="file"
                          name="eventPhoto"
                          onChange={handleChange}
                          class="form-control ps-3 normal-text bg-light border border-light rounded-3"
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Event photo for banner.
                        </p>
                      </div>
                      <div className="col-12">
                        <label className="label-text text-light mb-1 ms-3">
                          Event Description{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          type="text"
                          class="form-control ps-3 normal-text bg-light border border-light rounded-3"
                          rows="3"
                          placeholder="Enter Event Description"
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Enter few lines about your Event
                        </p>
                      </div>
                      <div className="col-12 my-lg-1 mt-5">
                        <h5 className="m-0 lh-1 text-light mt-4">
                          <i className="bi bi-lock"></i> Privacy
                        </h5>
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Privacy of sharing images of this event
                        </p>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <label className="label-text text-light mb-1 ms-3">
                          Guest access PIN{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="pin"
                          value={formData.pin}
                          onChange={handleChange}
                          maxLength={4}
                          class="form-control ps-3 normal-text bg-light border border-light rounded-3"
                          placeholder="Enter PIN"
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Please provide 4 digit PIN
                        </p>
                      </div>
                      <div className="col-lg-8 col-md-12">
                        <label className="label-text text-light mb-1 ms-3">
                          Event Phone No.{" "}
                          <span className="text-danger">
                            <span className="smtext">(Comma Seperated)</span> *
                          </span>
                        </label>
                        <textarea
                          type="text"
                          name="phones"
                          value={formData.phones}
                          onChange={handleChange}
                          class="form-control ps-3 normal-text bg-light border border-light rounded-3"
                          rows="2"
                          placeholder="Enter Phone No."
                        />
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 light-text-white">
                          Enter Phone No.(s) you want to grant direct access
                        </p>
                      </div>

                      <div className="col-lg-3 col-md-5 mt-lg-4 mt-6">
                        <button
                          type="submit"
                          disabled={loading}
                          className="btn btn-dark-primary border-0 px-4 rounded-3 fs-6 fw-medium"
                        >
                          {loading ? (
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            ></div>
                          ) : (
                            <>
                              <i className="bi bi-cloud me-1"></i> Update Event
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
            </div>

            <div className="col-lg-3 col-12">
              <Right />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default UpdateEvent;
